module.exports = __webpack_public_path__ + "img/step1-mobile.c822ad35.webp";